import qs from "qs";
import request from "@/utils/request";

export function getSysConfigSetting(keys) {
  return request({
    url: "/api/v2/sysConfig/setting",
    method: "post",
    data: qs.stringify({ keys }),
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
}
